import React from "react";

interface ConversationStartersProps {
  starters: string[];
  onStarterClick: (starter: string) => void;
  brandColor: string;
}

export const ConversationStarters: React.FC<ConversationStartersProps> = ({
  starters,
  onStarterClick,
  brandColor
}) => {
  if (!starters || starters.length === 0) return null;
  
  return (
    <div className="flex flex-wrap gap-2 py-2 justify-end">
      {starters.map((starter, index) => (
        <button
          key={index}
          onClick={() => onStarterClick(starter)}
          className="text-sm border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 px-3 py-1 rounded-lg"
          style={{
            borderColor: `${brandColor}50`,
            color: brandColor
          }}
        >
          {starter}
        </button>
      ))}
    </div>
  );
};
